import { render, staticRenderFns } from "./RedirectToETohyo.vue?vue&type=template&id=215229fd&"
import script from "./RedirectToETohyo.vue?vue&type=script&lang=js&"
export * from "./RedirectToETohyo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports